import { EditableComponent } from '@adobe/aem-react-editable-components';
import { StyledOutletOfferResult, StyledOutletOfferResultPreview } from './OutletOfferResult.styles';
import { OutletOfferResultInput } from './OutletOfferResult.types';
import { OutletOfferResultContainer } from './OutletOfferResultContainer';

export const OutletOfferResultWrapperConfig = {
  emptyLabel: 'OutletOfferResult',
  isEmpty: false,
  resourceType: `mi-aem-offers-spa/components/outletofferresult`,
};

export const OutletOfferResultWrapper: React.FC<OutletOfferResultInput> = props => {
  return <OutletOfferResultContainer {...props} />;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OutletOfferResult = (props: any) => {
  const isPreviewMode = props?.isPreview === 'true';
  const isNonEditable = props.cqPath?.includes('experiencefragment');

  const outletWrapper = isPreviewMode ? (
    <StyledOutletOfferResultPreview>
      <OutletOfferResultContainer {...props} />
    </StyledOutletOfferResultPreview>
  ) : (
    <StyledOutletOfferResult>
      <OutletOfferResultContainer {...props} />
    </StyledOutletOfferResult>
  );

  const outletOfferResultWrapper = (
    <div data-component-name="o-offers-outletofferresults" data-testid="outletofferresults">
      {outletWrapper}
    </div>
  );

  return isNonEditable ? (
    outletOfferResultWrapper
  ) : (
    <EditableComponent config={OutletOfferResultWrapperConfig} {...props}>
      {outletOfferResultWrapper}
    </EditableComponent>
  );
};
